

import { computed, ref } from 'vue'
import AuthRepository from '@/services/AuthRepository'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {Register} from "../models/register";
import {useStore} from "vuex";
import {KhoaPhong} from "@/models/khoaPhong";
import {DonViCreate} from "@/models/donViCreate";
import CDCRepository from "@/services/CDCRepository";

export default {

  setup(){
    const router = useRouter();
    const register = ref({} as Register);
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const emailPer = ref("");
    emailPer.value = "no";
    const khoaPhong = ref([] as KhoaPhong[]);
    const listDonVi = ref([] as DonViCreate[]);
    const getListDonVi = () => {
      CDCRepository.getListDonVi()
          .then((response) => {
            listDonVi.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }
    getListDonVi();
    //
    const valid = computed(()=> {
      const check = ref();
           check.value = register.value.password && register.value.username && register.value.fullname
              && register.value.phoneNumber;
          if(register.value.permission == "user")
          {
            check.value = check.value && register.value.idDonVi > 0 && register.value.report?.length > 0;
          }

          return check.value;
        }

    );
    const checkContent = computed(() =>{
      console.log("########################## check register: " + JSON.stringify(register.value));
      console.log("########################## check report: " + JSON.stringify(register.value.report));
    })

    if(!(store.state.permission == 'admin')){
      router.push({
        name: 'home'
      });
    }

    register.value.permission = 'user';

    const userPermission = ref([
      {label: "Quản lý", value: "admin", param: 1},
      {label: "Nhân viên", value: "user", param: 2},
    ]);
    const reportList = ref([
      {label: "BC Cơ sở lao động", key: "bc1"},
      {label: "BC YTLĐ tuyến huyện", key: "bc2"},
      {label: "BC Kiểm dịch y tế", key: "bc3"},
      {label: "BC công tác y tế trường học", key: "bc4"},
      {label: "BC vệ sinh nước sạch", key: "bc5"},
      {label: "BC tiêm vắc xin", key: "bc6"},
      {label: "BC tình hình sử dụng vắcxin", key: "bc7"},
      {label: "BC sàng lọc bệnh KLN và KSKDK", key: "bc8"},
    ]);
    const doRegister = () => {
      if(register.value.password.length < 6)
      {
        toast.add({
          severity: 'error',
          summary: 'Thất bại',
          detail: 'Mật khẩu không hợp lệ, vui lòng nhập lại mật khẩu',
          life: 2000
        });
      }
      else {
        if(register.value.report.length > 0){
          register.value.report = register.value.report.toString();
        }
        AuthRepository.registerUser(register.value)
                .then((response) => {
                  toast.add({
                    severity: 'success',
                    summary: 'Đăng ký',
                    detail: 'Đăng ký thành viên thành công vào hệ thống',
                    life: 2000
                  });
                  router.push({
                    name: 'userlist'
                  });
                })
                .catch(err => {
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail:err.response.data,
                    life: 2000
                  });
                });
      };
    }

    return {
      register,
      doRegister,
      valid,
      userPermission,
      error,
      emailPer,
      khoaPhong,
      listDonVi,
      reportList,
      checkContent
    }
  }
}

